import React from "react";
import {
  Button, DialogActions, DialogContent, Grid
} from '@mui/material';
import TextInput from "@/common/components/text-input/text-input";
import Dropdown from "@/common/components/dropdown/dropdown";
import SwitchInput from "@/common/components/switch-input/switch-input";
import AnimateButton from "@/from-theme/components/@extended/AnimateButton";
import { FormattedMessage } from 'react-intl';
import useCreateEditDropdownListMaster from "./hooks/useCreateEditDropdownListMaster";
import useGetDropdownOptions from "@/common/hooks/useGetDropdownMaster";
import PropTypes from "prop-types";
import { apiStatuses } from "@/store/api/constants";
import Spinner from "@/common/components/spinner/spinner";
import ErrorInPage from "@/common/components/error-in-page/error-in-page";


function CreateEditDropdownListMaster({
  closeModal, activeEditId
}) {

  const { getDropdownOptions, getDropdownLoading } = useGetDropdownOptions();
  const {
    values, formik, getEditDropdownlistMasterStatus,
    getEditDropdownlistMasterErrMsg, saveDropdownlistMasterStatus, updateDropdownlistMasterStatus,
  } = useCreateEditDropdownListMaster(activeEditId);
  
  const isPending = [saveDropdownlistMasterStatus, updateDropdownlistMasterStatus]
  .includes(apiStatuses.pending);


  const {
    listShortName, dropdownListName, dropdownId, activeStatus
  } = values;

  return (
    <>
      {
        getEditDropdownlistMasterStatus === apiStatuses.pending && activeEditId
        && <Spinner />
      }

      {getEditDropdownlistMasterStatus === apiStatuses.rejected && activeEditId && (
        <ErrorInPage message={getEditDropdownlistMasterErrMsg} />
      )}

      {(getEditDropdownlistMasterStatus === apiStatuses.succeeded || !activeEditId) &&
        <form onSubmit={formik.handleSubmit}>
          <DialogContent dividers>
            <Grid container spacing={1.25} style={{ paddingBottom: '240px' }}>
              <Grid item xs={12} sm={12} md={4} lg={6}>
                <TextInput
                  placeholder="short-name" size="small" fullWidth
                  value={listShortName}
                  inputLabel="short-name"
                  formik={formik}
                  name="listShortName"
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={6}>
                <TextInput
                  placeholder="dropdownlist-name" size="small" fullWidth
                  value={dropdownListName}
                  inputLabel="dropdownlist-name"
                  formik={formik}
                  name="dropdownListName"
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={6}>
                <Dropdown
                  options={getDropdownOptions}
                  loading={getDropdownLoading}
                  placeholder="dropdown-name"
                  inputLabel="dropdown-name"
                  value={dropdownId}
                  formik={formik}
                  name="dropdownId"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={6}>
                <SwitchInput
                  inputLabel="activeStatus"
                  leftLabel="inactive"
                  rightLabel="active"
                  value={activeStatus}
                  formik={formik}
                  name="activeStatus"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button color="error" onClick={closeModal} disabled={isPending} 
            variant="outlined" sx={{ mr: 1 }}>
              <FormattedMessage id={"cancel"} />
            </Button>
            <AnimateButton>
              <Button type="submit" variant="contained" disabled={isPending} sx={{ mr: 1 }}>
                <FormattedMessage id={"save"} />
              </Button>
            </AnimateButton>
          </DialogActions>
        </form>
      }
    </>
  )
}

CreateEditDropdownListMaster.propTypes = {
  closeModal: PropTypes.func.isRequired,
  activeEditId: PropTypes.bool,
};

CreateEditDropdownListMaster.defaultProps = {
  activeEditId: 0,
};

export default CreateEditDropdownListMaster;